import { render, staticRenderFns } from "./SpinToWinOfficalRules.vue?vue&type=template&id=4084cc16&scoped=true&"
import script from "./SpinToWinOfficalRules.vue?vue&type=script&lang=ts&"
export * from "./SpinToWinOfficalRules.vue?vue&type=script&lang=ts&"
import style0 from "./SpinToWinOfficalRules.vue?vue&type=style&index=0&id=4084cc16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084cc16",
  null
  
)

export default component.exports